import React, { useState } from 'react';

// MUI
import MUIDataTable from 'mui-datatables';
import util from '../../utils/utils';
import Dialog from '@mui/material/Dialog';
import ImportProgressPreview from '../Workspace/DataSources/ImportWizard/ImportProgressPreview';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { TransitionProps } from '@mui/material/transitions';
import Slide from '@mui/material/Slide';
import { workspaceActions } from '../Workspace/WorkspaceActions';
import { useDispatch } from 'react-redux';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export const InfoTable = ({ list, columns, toolbar, activeTab, ...props }) => {
    const dispatch = useDispatch();
    const [openProgress, setOpenProgress] = useState(false);

    const handleRowClick = (data) => {
        if (activeTab !== 'diagnoses' && activeTab !== 'toxResults') {
            dispatch(workspaceActions?.getImportStatus(data[0]));
            setOpenProgress(true);
        }
    };

    const handleCloseProgress = () => {
        dispatch(workspaceActions?.resetFileImportStatus());
        setOpenProgress(false);
    };

    const headers = columns.map((c) => ({
        name: c,
        label: util.toTitleText(c),
        options: {
            display: !(c === 'id' || c.indexOf(`__customSort`) > -1),
            sort: true,
        },
    }));

    // Setup MUI Data Table options including custom toolbar with custom buttons and functions
    const options = {
        rowsPerPageOptions: [10, 25, 100],
        print: false,
        download: false,
        filter: false,
        viewColumns: false,
        selectableRows: 'none',
        elevation: 0,
        pagination: true,
        textLabels: {
            body: {
                noMatch: 'There are no items available',
            },
        },
        search: false,
        serverSide: false,
        onRowClick: (rowData) => handleRowClick(rowData),
        customSort: (data, dataIndex, rowIndex) => {
            if (columns.includes(`${columns[dataIndex]}__customSort`)) {
                const fieldToSort = `${columns[dataIndex]}__customSort`;
                const indexToSort = columns.indexOf(fieldToSort);
                return data.sort(
                    (a, b) =>
                        (a.data[indexToSort] < b.data[indexToSort] ? -1 : 1) *
                        (rowIndex === 'desc' ? 1 : -1)
                );
            }
            return data.sort(
                (a, b) =>
                    (a.data[dataIndex] < b.data[dataIndex] ? -1 : 1) *
                    (rowIndex === 'desc' ? 1 : -1)
            );
        },
    };

    const data = [];
    list &&
        // eslint-disable-next-line array-callback-return
        list.map((item: { [x: string]: any }) => {
            const array = [];
            columns.forEach((c: string | number) => {
                array.push(item[c]);
            });
            data.push(array);
        });
    return (
        <>
            <MUIDataTable
                title=""
                data={data}
                columns={headers}
                // @ts-ignore
                options={options}
            />
            <Dialog
                onClose={handleCloseProgress}
                open={openProgress}
                fullWidth
                maxWidth={'lg'}
                TransitionComponent={Transition}
                keepMounted
            >
                <ImportProgressPreview />
                <DialogActions>
                    <Button onClick={handleCloseProgress}>Close</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default InfoTable;
